import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { exportStatusLabels } from "../../../components/Badge";

const filterDownloadCenterSchema = z.object({
  client_contains: z.string().optional(),
  user_contains: z.string().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  report_date_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  report_date_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  file_name_contains: z.string().optional(),
  status_in: z.string().optional(),
});

const filterDownloadCenterFields = filterDownloadCenterSchema.keyof().enum;

export type FilterDownloadCenterSchemaType = z.infer<
  typeof filterDownloadCenterSchema
>;

export function FilterDownloadCenter() {
  const { t } = useTranslation();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: filterDownloadCenterFields.client_contains,
        label: "Client",
        type: "input",
      },
      {
        name: filterDownloadCenterFields.user_contains,
        label: t("download_center.columns.user_name", {
          defaultValue: "Utilisateur",
        }),
        type: "input",
      },
      {
        name: filterDownloadCenterFields.file_name_contains,
        label: t("download_center.columns.file_name", {
          defaultValue: "Nom du fichier",
        }),
        type: "input",
      },
      {
        name: filterDownloadCenterFields.status_in,
        label: t("download_center.columns.status", { defaultValue: "Statut" }),
        type: "select",
        useTranslation: false,
        options: exportStatusLabels(t),
      },
      {
        name: "created_at",
        type: "dateRange",
        label: t("download_center.columns.created_at", {
          defaultValue: "Date de génération",
        }),
        from: { name: filterDownloadCenterFields.created_at_from },
        to: { name: filterDownloadCenterFields.created_at_to },
      },
      {
        name: "report_date",
        type: "dateRange",
        label: t("download_center.columns.reporting_date", {
          defaultValue: "Date du rapport",
        }),
        from: { name: filterDownloadCenterFields.report_date_from },
        to: { name: filterDownloadCenterFields.report_date_to },
      },
    ],
    [t],
  );
  return (
    <FilterTable
      schema={filterDownloadCenterSchema}
      client={Clients.D1}
      tableName="d1_download_center"
      fields={fields}
    />
  );
}
